import featureLight from '../../feature/light';

const light = (params) => featureLight(params);

export default light;
